<!-- <ion-header *ngIf="db.ismobile && modal">
  <ion-toolbatr>
    <div class="d__flex just-s report" >
      <ion-title>Reports</ion-title>
      <ion-icon name="close-outline" class="mouse"  (click)="modalCtrl.dismiss()"></ion-icon>
    </div>
  </ion-toolbatr>
</ion-header> -->


<div class="list">
  <div *ngIf="db.ismobile && modal" class="d__flex header">
    <!-- <h6 class="m-0 heading">Centre Selection</h6> -->
    <div>
      <h6 class="m-0 heading__">Reports</h6>
    </div>
    <ion-icon (click)="modalCtrl.dismiss()"  class="mouse" name="close-outline"></ion-icon>
  </div>

  <ul class="filer-menu">
    <li class="d__flex headers_div" *ngIf="!db.ismobile" style="border-bottom: 1px solid #ddd;padding: 10px;">
      <ion-title class="title__popup title">Reports</ion-title>
      <ion-icon *ngIf="db.ismobile && db.modal_popup" slot="end" class="close_icon" name="close" (click)="close()"></ion-icon>
    </li>
    <li (click)="goto('sales','Sales Report')" [ngClass]="isMenu.sales?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/salce-report.svg" slot="start"></ion-icon> <span class="span_txt">Sales Report</span></p>
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li>
    <li (click)="goto('daily','Daily Sales Report')" [ngClass]="isMenu.daily?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/daily-salce-report.svg" slot="start"></ion-icon> <span class="span_txt">Daily Sales Report</span></p>
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li>
    <li (click)="goto('monthly','Monthly Sales Report')" [ngClass]="isMenu.monthly?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/monthly-salce-report.svg" slot="start"></ion-icon> <span class="span_txt">Monthly Sales Report</span></p>
      <!-- Monthly Sales Report -->
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li>
    <li (click)="goto('yearly','Yearly Sales Report')" [ngClass]="isMenu.yearly?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/yearly-salce-report.svg" slot="start"></ion-icon> <span class="span_txt">Yearly Sales Report</span></p>
      <!-- Yearly Sales Report -->
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li> 
    <!-- <li (click)="goto('customer','Customer Wise Sales Report')" [ngClass]="isMenu.customer?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/Reports-icons/Customers-Reports.svg" slot="start"></ion-icon> <span class="span_txt">Customer Wise Sales Report</span></p>
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li> -->
    <li (click)="goto('best_item_price','Best Selling Item By Amount')" [ngClass]="isMenu.best_item_price?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/best-seling-iteam-by-amount.svg" slot="start"></ion-icon> <span class="span_txt">Best Selling Item By Amount</span></p>
      <!-- Best Selling Item By Amount -->
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li>
    <li (click)="goto('best_item_quantity','Best Selling Item By Quantity')" [ngClass]="isMenu.best_item_quantity?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/best-seling-iteam-by-quantily.svg" slot="start"></ion-icon> <span class="span_txt">Best Selling Item By Quantity</span></p>
      <!-- Best Selling Item By Quantity -->
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li>
    <!-- <li (click)="goto('vendor_order','Vendor Order')" [ngClass]="isMenu.vendor_order?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/sales report.svg" slot="start"></ion-icon> <span class="span_txt">Vendor Order</span></p>
      
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li> -->
    <li (click)="goto('product_report','Product Report')" [ngClass]="isMenu.product_report?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/product-report.svg" slot="start"></ion-icon> <span class="span_txt">Product Report</span></p>
      <!-- Product Report -->
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li>
    <li (click)="goto('item_sales_report','Item Wise Sales Report')" [ngClass]="isMenu.item_wise_sales_report?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/item-wise-sales-report.svg" slot="start"></ion-icon> <span class="span_txt">Item Wise Sales Report</span></p>
      <!-- Item Wise Sales Report -->
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li>
    <li (click)="goto('commission_report','Commission Report')" [ngClass]="isMenu.commission_report?'menu-items-active main-item':'menu-items main-item'">
      <p class="m0 pos_relative"><ion-icon class="f36" src="assets/icon/reports/commission-report.svg" slot="start"></ion-icon> <span class="span_txt">Commission Report</span></p>
      <!-- Commission Report -->
      <ion-icon class="pt8" name="chevron-forward-outline" slot="end"></ion-icon>
    </li>
  </ul>


</div>



